<template>
  <v-dialog :value="value" @input="$emit('input', $event)" width="700" persistent no-click-animation scrollable overlay-color="overlay">
    <v-card>
      <v-toolbar class="transparent" flat height="46">
        <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-semibold">{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-row align="center" justify="center" class="mr-4">
            <v-btn @click="$emit('input', false)" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
          </v-row>
        </v-toolbar-items>
      </v-toolbar>
      <v-divider />
      <render-pdf
        :basicRender="true"
        :loaderRender="loaderRender"
        :renderUrl="renderUrl"
        :flat="true"
        :showToolbar="false"
        :showTemplateSelector="false"
        :showFooter="false"
      />
      <v-divider />
      <v-card-actions class="py-2 px-5">
        <v-btn @click="$emit('input', false)" outlined>Cancelar</v-btn>
        <v-spacer />
        <v-btn @click="$emit('continue')" color="blue-500">Continuar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RenderPdf from '@/components/files/RenderPdf'

export default {
  name: 'DocumentPdfPreviewDialog',
  components: { RenderPdf },
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: '' },
    loaderRender: { type: Boolean, default: false },
    renderUrl: { type: [String, Object], default: null }
  }
}
</script>
